import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import LogicaAPI from "./logicaapi";

var Subscribe = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(Subscribe, _LogicaAPI);

  var _super = _createSuper(Subscribe);

  function Subscribe() {
    _classCallCheck(this, Subscribe);

    return _super.apply(this, arguments);
  }

  _createClass(Subscribe, [{
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(courseId, paymentInstrumentId, voucherCode) {
        var params, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  course_id: courseId,
                  payment_instrument_id: paymentInstrumentId,
                  with_course: true,
                  with_course_pricing: true
                };

                if (voucherCode) {
                  params.voucher_code = voucherCode;
                }

                console.log("subscribe", params);
                res = this.post("/api/v1/subscriptions/subscribe", {
                  body: params
                });
                return _context.abrupt("return", res);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function subscribe(_x, _x2, _x3) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "subscription",
    value: function () {
      var _subscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  with_course: true,
                  with_payment_instrument: true,
                  with_course_pricing: true,
                  status_scope: "active",
                  with_entitlements: true
                };
                return _context2.abrupt("return", this.get("/api/v1/subscriptions", {
                  params: params
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function subscription() {
        return _subscription.apply(this, arguments);
      }

      return subscription;
    }()
  }, {
    key: "subscriptionStatus",
    value: function () {
      var _subscriptionStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(courseId) {
        var params;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  course_id: courseId
                };
                return _context3.abrupt("return", this.get("/api/v1/subscriptions/status", {
                  params: params
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function subscriptionStatus(_x4) {
        return _subscriptionStatus.apply(this, arguments);
      }

      return subscriptionStatus;
    }()
  }, {
    key: "subscriptionOne",
    value: function () {
      var _subscriptionOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(subscriptionId) {
        var params;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  with_course: true,
                  with_payment_instrument: true,
                  with_course_pricing: true,
                  with_entitlements: true
                };
                return _context4.abrupt("return", this.get("/api/v1/subscriptions/".concat(subscriptionId), {
                  params: params
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function subscriptionOne(_x5) {
        return _subscriptionOne.apply(this, arguments);
      }

      return subscriptionOne;
    }()
  }, {
    key: "subscriptionCancel",
    value: function () {
      var _subscriptionCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var params, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  course_id: id
                };
                console.log("subscriptionCancel", params);
                res = this.post("/api/v1/subscriptions/cancel", {
                  body: params
                });
                return _context5.abrupt("return", res);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function subscriptionCancel(_x6) {
        return _subscriptionCancel.apply(this, arguments);
      }

      return subscriptionCancel;
    }()
  }, {
    key: "subscriptionCheckCancelable",
    value: function () {
      var _subscriptionCheckCancelable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(subscriptionId) {
        var params;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {
                  subscription_id: subscriptionId
                };
                return _context6.abrupt("return", this.post("/api/v1/subscriptions/check_cancelable", {
                  body: params
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function subscriptionCheckCancelable(_x7) {
        return _subscriptionCheckCancelable.apply(this, arguments);
      }

      return subscriptionCheckCancelable;
    }()
  }, {
    key: "subscriptionChangePayment",
    value: function () {
      var _subscriptionChangePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(args) {
        var params;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  payment_instrument_id: args.paymentInstrumentId
                };
                return _context7.abrupt("return", this.post("/api/v1/subscriptions/".concat(args.subscriptionId, "/edit"), {
                  body: params
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function subscriptionChangePayment(_x8) {
        return _subscriptionChangePayment.apply(this, arguments);
      }

      return subscriptionChangePayment;
    }()
  }, {
    key: "formQuestions",
    value: function () {
      var _formQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(args) {
        var res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                res = this.get("/api/v1/form/question/".concat(args.id));
                return _context8.abrupt("return", res);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function formQuestions(_x9) {
        return _formQuestions.apply(this, arguments);
      }

      return formQuestions;
    }()
  }, {
    key: "formQuestionAnswer",
    value: function () {
      var _formQuestionAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id, values) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.post("/api/v1/form/question/".concat(id, "/answers"), {
                  body: {
                    values: values
                  }
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function formQuestionAnswer(_x10, _x11) {
        return _formQuestionAnswer.apply(this, arguments);
      }

      return formQuestionAnswer;
    }()
    /**
     * estimate.
     *
     * @param {Integer} courseId
     * @param {Integer} paymentMethodId
     * @param {String} couponCode
     */

  }, {
    key: "estimate",
    value: function () {
      var _estimate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(courseId, paymentMethodId, couponCode) {
        var params;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                params = {
                  course_id: courseId
                };

                if (paymentMethodId) {
                  params.paymentMethodId = paymentMethodId;
                }

                if (couponCode) {
                  params.use_coupon = true;
                  params.coupon_code = couponCode;
                }

                return _context10.abrupt("return", this.get("/api/v1/subscribe_process/estimate", {
                  params: params
                }));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function estimate(_x12, _x13, _x14) {
        return _estimate.apply(this, arguments);
      }

      return estimate;
    }()
    /**
     * applyCoupon.
     *
     * @param {Integer} courseId
     * @param {Integer} paymentMethodId
     * @param {String} campaignCode
     */

  }, {
    key: "applyCampaign",
    value: function () {
      var _applyCampaign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(courseId, campaignCode) {
        var params;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                params = {
                  course_id: courseId,
                  coupon_code: campaignCode
                };
                return _context11.abrupt("return", this.get("/api/v1/subscribe_process/apply_coupon", {
                  params: params
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function applyCampaign(_x15, _x16) {
        return _applyCampaign.apply(this, arguments);
      }

      return applyCampaign;
    }()
    /**
     * subscriptionFromCourseId.
     *
     * @param {Integer} courseId
     */

  }, {
    key: "subscriptionFromCourseId",
    value: function () {
      var _subscriptionFromCourseId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(courseId) {
        var _res$subscriptions, _res$subscriptions$;

        var params, res;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                params = {
                  with_subscription: true,
                  course_id: courseId
                };
                _context12.next = 3;
                return this.get("/api/v1/users/subscription_status_histories", {
                  params: params
                });

              case 3:
                res = _context12.sent;
                return _context12.abrupt("return", res === null || res === void 0 ? void 0 : (_res$subscriptions = res.subscriptions) === null || _res$subscriptions === void 0 ? void 0 : (_res$subscriptions$ = _res$subscriptions[0]) === null || _res$subscriptions$ === void 0 ? void 0 : _res$subscriptions$.subscription);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function subscriptionFromCourseId(_x17) {
        return _subscriptionFromCourseId.apply(this, arguments);
      }

      return subscriptionFromCourseId;
    }()
  }]);

  return Subscribe;
}(LogicaAPI);

export default Subscribe;